// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import { post, get } from './assets/http.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$post = post;
Vue.prototype.$get = get;

Vue.use(ElementUI);
Vue.config.productionTip = false

window.gloabFile = 'http://test.glkj.online/face-merge/'
// window.gloabFile = 'http://192.168.31.187:8080/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js